import React from 'react';
import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Paper,
  Tab,
  Tabs,
  Typography
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import SemanticTableCard from './SemanticTableCard';

const SemanticTableSection = ({
  activeRecords = [],
  deletedRecords = [],
  filter,
  onFilterChange,
  onCreate,
  onView,
  onEdit,
  onDelete,
  isLoading,
  error,
  databaseIndex = {}
}) => {
  const recordsToRender = filter === 'deleted' ? deletedRecords : activeRecords;

  return (
    <Paper
      elevation={0}
      sx={{
        bgcolor: 'var(--wb-bg-elevated)',
        p: 3,
        borderRadius: 2,
        mb: 4
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          mb: 3,
          flexWrap: 'wrap',
          gap: 2
        }}
      >
        <Box>
          <Typography variant="h6" color="var(--wb-text-strong)">
            Entidades semánticas
          </Typography>
          <Tabs
            value={filter}
            onChange={(_, value) => onFilterChange?.(value)}
            textColor="secondary"
            indicatorColor="secondary"
            sx={{ mt: 1 }}
          >
            <Tab
              label={`Activas (${activeRecords.length})`}
              value="active"
              sx={{ color: 'var(--wb-text)' }}
            />
            <Tab
              label={`Eliminadas (${deletedRecords.length})`}
              value="deleted"
              sx={{ color: 'var(--wb-text)' }}
            />
          </Tabs>
        </Box>

        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={onCreate}
          sx={{
            bgcolor: 'var(--wb-indigo)',
            '&:hover': { bgcolor: 'var(--wb-x-bg-4f46e5, #4f46e5)' }
          }}
        >
          Nueva entidad
        </Button>
      </Box>

      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}

      {isLoading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', py: 6 }}>
          <CircularProgress sx={{ color: 'var(--wb-accent)' }} />
        </Box>
      ) : recordsToRender.length === 0 ? (
        <Box sx={{ textAlign: 'center', py: 6 }}>
          <Typography variant="body1" color="var(--wb-text-strong)">
            {filter === 'deleted'
              ? 'No hay entidades semánticas eliminadas.'
              : 'Todavía no se han registrado entidades semánticas.'}
          </Typography>
        </Box>
      ) : (
        recordsToRender.map((item) => (
          <SemanticTableCard
            key={item?.table_id || item?.table_name}
            record={item}
            database={databaseIndex[item?.semantic_database_id]}
            onView={onView}
            onEdit={onEdit}
            onDelete={onDelete}
            isDeleted={filter === 'deleted' || item?.soft_delete?.deleted}
          />
        ))
      )}
    </Paper>
  );
};

export default SemanticTableSection;
